// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2H9VK","form":"styles_form__1hDQ2"};